import React, { useContext, useEffect, useRef } from "react";

/* plugin */
import { Player } from "@lottiefiles/react-lottie-player";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "react-toastify";
import { useAutoAnimate } from "@formkit/auto-animate/react";
/* plugin end */

/* service */
import gs from "../../services/global";
import AuthContext from "../../store/auth-context";
import { stepFun, toasterConfig } from "../../utils/Constant";
/* service end */

/* component */
import animationData from "../../assests/json/loader_1.json";
import Header from "../../components/Header";
import InnerBgComp from "../../components/InnerBgComp";
/* component end */

const { REACT_APP_FLOWID } = process.env;

const PreScoring = () => {
  const authCtx = useContext(AuthContext);
  const instanceId = authCtx?.instanceId;

  const navigate = useNavigate();

  const [preScoringAnim] = useAutoAnimate();
  const loaderAnim = useRef(null);
  const animPlay = () => {
    loaderAnim.current.play();
  };

  useEffect(() => {
    const submitTimer = setTimeout(() => {
      const payload = {
        action: "submit",
        data: {},
      };
      axios
        .post(`/flow/${REACT_APP_FLOWID}/instances/${instanceId}`, payload)
        .then((response) => {
          const result = response?.data;
          const currentStep = result?.currentStepId;

          const preScoringDecision =
            result?.responseData?.pre_scoring_decision || "";
          localStorage.setItem("preScoringDecision", preScoringDecision);

          navigate(stepFun()[currentStep], { replace: true });
          authCtx.prefilledDataFunc(result?.prefilledData);
        })
        .catch((error) => {
          const errorEnd = error?.response?.data?.currentStepId;
          navigate(stepFun()[errorEnd], { replace: true });

          const serverError = error?.response?.data?.error?.message;
          if (serverError) {
            toast.error(serverError, toasterConfig);
          }

          const errorResult = error?.response?.data?.errors?.[0];
          if (errorResult) {
            const arrayFlatten = Object.values(errorResult).flat();
            for (let itemData of arrayFlatten) {
              toast.error(itemData, toasterConfig);
            }
          }

          gs.showLoader(false);
        });
    }, 500);

    return () => clearTimeout(submitTimer);
  }, [instanceId]);

  return (
    <div>
      <Header colorLogo={true} />

      <div className="main-container">
        <InnerBgComp classes={"inner-bg-img add-bg-mob"} />

        <div className="container">
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="comm-box congo-box"
          >
            <div
              className="congo-cont"
              style={{ maxWidth: 275, marginBottom: 24 }}
            >
              <div ref={preScoringAnim}>
                <motion.h4
                  initial={{ y: 60, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  className="congo-hdn"
                  style={{ marginBottom: 10 }}
                >
                  Checking eligibility
                </motion.h4>
                <motion.div
                  initial={{ y: 60, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="congo-para"
                >
                  <p>
                    We&rsquo;re running a quick check to confirm your
                    eligibility. This won&rsquo;t affect your credit score.
                  </p>
                </motion.div>
              </div>
            </div>
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="congo-lottie"
              style={{ marginBottom: 0 }}
            >
              <Player
                onEvent={(event) => {
                  if (event === "load") {
                    animPlay();
                  }
                }}
                ref={loaderAnim}
                autoplay={true}
                loop={true}
                controls={true}
                src={animationData}
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PreScoring;